module.exports = __webpack_public_path__ + "img/product14-fenan.d258d729.svg";